export enum Preference {
  GlobalPreference = 'globalPreference',
  UserPreference = 'userPreference',
  GroupPreference = 'groupPreference',
}

export const MAX_STANDARD_PRINT_LINE_TAGS = 6;

export const PRINT_LABEL_LINE1 = 'Print.Label.Line1';
export const PRINT_LABEL_LINE2 = 'Print.Label.Line2';
export const PRINT_LABEL_LINE3 = 'Print.Label.Line3';
export const PRINT_LABEL_LINE4 = 'Print.Label.Line4';
export const PRINT_LABEL_LINE5 = 'Print.Label.Line5';
export const PRINT_LABEL_LINE6 = 'Print.Label.Line6';
export const PRINT_LABEL_EXPERIMENTINFORMATION_LINE1 =
  'Print.Label.ExperimentInformation.Line1';
export const PRINT_LABEL_EXPERIMENTINFORMATION_LINE2 =
  'Print.Label.ExperimentInformation.Line2';
export const PRINT_LABEL_EXPERIMENTINFORMATION_LINE3 =
  'Print.Label.ExperimentInformation.Line3';
export const PRINT_LABEL_EXPERIMENTINFORMATION_LINE4 =
  'Print.Label.ExperimentInformation.Line4';
export const PRINT_LABEL_EXPERIMENTINFORMATION_LINE5 =
  'Print.Label.ExperimentInformation.Line5';
export const PRINT_LABEL_EXPERIMENTINFORMATION_LINE6 =
  'Print.Label.ExperimentInformation.Line6';
export const PRINTING_LABEL_PRINTER_NAME = 'Printing.LabelPrinterName';
export const LABEL_PRINTING_LABEL_AUTO_FORM_FEED_COUNT =
  'LabelPrinting.LabelAutoFormFeedCount';
export const LABEL_PRINTING_MULTI_COPIES_PRINT_COUNT =
  'LabelPrinting.MultiCopiesPrintCount';
export const LABEL_PRINTING_DATE_FORMAT = 'LabelPrinting.DateFormat';
export const PRINTING_LABEL_PRINTER_USE_GENERIC_BARCODES =
  'Printing.LabelPrinter.UseGenericBarcodes';
export const PRINTING_LABEL_PRINTER_USE_MODIFIED_BASE64_BARCODES =
  'Printing.LabelPrinter.UseModifiedBase64Barcodes';
export const PRINT_LABEL_MIN_CHARS_PER_TRUNCATED_TAG =
  'Print.Label.MinCharsPerTruncatedTag';
export const BARCODE_SYSTEM_NAME = 'Barcode.System.Name';
export const PRINTING_LABEL_PRINTER = 'Printing.LabelPrinter';
export const PRINTING_LABEL_PRINTER_PLATE_NUM_CHARS_PER_LINE =
  'Printing.LabelPrinter.Plate.NumCharsPerLine';
export const PRINTING_LABEL_PRINTER_PLATE_HORIZ_TEXT_OFFSET =
  'Printing.LabelPrinter.Plate.HorizTextOffset';
export const PRINTING_LABEL_PRINTER_PLATE_HORIZ_BARCODE_OFFSET =
  'Printing.LabelPrinter.Plate.HorizBarcodeOffset';
export const PRINTING_LABEL_PRINTER_PLATE_BARCODE_COMMAND =
  'Printing.LabelPrinter.Plate.BarcodeCommand';
export const PRINTING_LABEL_PRINTER_PLATE_BARCODE_TEXT_VERTICAL_OFFSET =
  'Printing.LabelPrinter.Plate.BarcodeTextVerticalOffset';
export const PRINTING_LABEL_PRINTER_PLATE_DISPLAY_BARCODE_TEXT =
  'Printing.LabelPrinter.Plate.DisplayBarcodeText';
export const PRINTING_LABEL_PRINTER_PLATE_PRINT_BARCODE2 =
  'Printing.LabelPrinter.Plate.PrintBarcode2';
export const PRINTING_LABEL_PRINTER_PLATE_HORIZ_TEXT_OFFSET2 =
  'Printing.LabelPrinter.Plate.HorizTextOffset2';
export const PRINTING_LABEL_PRINTER_PLATE_HORIZ_BARCODE_OFFSET2 =
  'Printing.LabelPrinter.Plate.HorizBarcodeOffset2';
export const PRINTING_LABEL_PRINTER_PLATE_BARCODE_COMMAND2 =
  'Printing.LabelPrinter.Plate.BarcodeCommand2';
export const PRINTING_LABEL_PRINTER_PLATE_BARCODE_TEXT_HORIZONTAL_OFFSET2 =
  'Printing.LabelPrinter.Plate.BarcodeTextHorizontalOffset2';
export const PRINTING_LABEL_PRINTER_PLATE_BARCODE_TEXT_VERTICAL_OFFSET2 =
  'Printing.LabelPrinter.Plate.BarcodeTextVerticalOffset2';
export const PRINTING_LABEL_PRINTER_PLATE_DISPLAY_BARCODE_TEXT2 =
  'Printing.LabelPrinter.Plate.DisplayBarcodeText2';
export const PRINTING_LABEL_PRINTER_PLATE_PRINT_BARCODE_DELAY =
  'Printing.LabelPrinter.Plate.PrintBarcodeDelay';
export const PRINTING_LABEL_PRINTER_INGREDIENT_GENERIC_BARCODE_LENGTH =
  'Printing.LabelPrinter.Ingredient.GenericBarcodeLength';
export const PRINTING_LABEL_PRINTER_INGREDIENT_NUM_CHARS_PER_LINE =
  'Printing.LabelPrinter.Ingredient.NumCharsPerLine';
export const PRINTING_LABEL_PRINTER_INGREDIENT_HORIZ_TEXT_OFFSET =
  'Printing.LabelPrinter.Ingredient.HorizTextOffset';
export const PRINTING_LABEL_PRINTER_INGREDIENT_HORIZ_BARCODE_OFFSET =
  'Printing.LabelPrinter.Ingredient.HorizBarcodeOffset';
export const PRINTING_LABEL_PRINTER_INGREDIENT_BARCODE_COMMAND =
  'Printing.LabelPrinter.Ingredient.BarcodeCommand';
export const PRINTING_LABEL_PRINTER_INGREDIENT_BARCODE_TEXT_VERTICAL_OFFSET =
  'Printing.LabelPrinter.Ingredient.BarcodeTextVerticalOffset';
export const PRINTING_LABEL_PRINTER_INGREDIENT_DISPLAY_BARCODE_TEXT =
  'Printing.LabelPrinter.Ingredient.DisplayBarcodeText';
export const PRINTING_LABEL_PRINTER_INGREDIENT_PRINT_DATE =
  'Printing.LabelPrinter.Ingredient.PrintDate';
export const PRINTING_LABEL_PRINTER_INGREDIENT_NULL_BARCODE =
  'Printing.LabelPrinter.Ingredient.NullBarcode';
export const PRINTING_LABEL_PRINTER_PLATE_GENERIC_BARCODE_LENGTH =
  'Printing.LabelPrinter.Plate.GenericBarcodeLength';
export const PRINTING_LABEL_PRINTER_PLATE_PLATE_TYPE_ID =
  'Printing.LabelPrinter.Plate.PlateTypeID';
export const PRINTING_LABEL_PRINTER_PLATE_PLATE_ID_ENCODING =
  'Printing.LabelPrinter.Plate.PlateIDEncoding';
export const PRINTING_LABEL_PRINTER_INGREDIENT_INGREDIENT_ID_ENCODING =
  'Printing.LabelPrinter.Ingredient.IngredientIDEncoding';
export const PRINTING_LABEL_PRINTER_EXPERIMENTINFORMATION_NUM_CHARS_PER_LINE =
  'Printing.LabelPrinter.ExperimentInformation.NumCharsPerLine';
export const PRINTING_LABEL_PRINTER_EXPERIMENTINFORMATION_HORIZ_TEXT_OFFSET =
  'Printing.LabelPrinter.ExperimentInformation.HorizTextOffset';
export const PRINTING_LABEL_PRINTER_EXPERIMENTINFORMATION_BARCODE_COMMAND =
  'Printing.LabelPrinter.ExperimentInformation.BarcodeCommand';

export const PRINT_LINE_PROPERTY_NAMES = [
  PRINT_LABEL_LINE1,
  PRINT_LABEL_LINE2,
  PRINT_LABEL_LINE3,
  PRINT_LABEL_LINE4,
  PRINT_LABEL_LINE5,
  PRINT_LABEL_LINE6,
  PRINT_LABEL_EXPERIMENTINFORMATION_LINE1,
  PRINT_LABEL_EXPERIMENTINFORMATION_LINE2,
  PRINT_LABEL_EXPERIMENTINFORMATION_LINE3,
  PRINT_LABEL_EXPERIMENTINFORMATION_LINE4,
  PRINT_LABEL_EXPERIMENTINFORMATION_LINE5,
  PRINT_LABEL_EXPERIMENTINFORMATION_LINE6,
] as const;

export type PrintLinePropertyName = (typeof PRINT_LINE_PROPERTY_NAMES)[number];

export const isPrintLineProperty = (
  propertyName: string,
): propertyName is PrintLinePropertyName => {
  return (PRINT_LINE_PROPERTY_NAMES as readonly string[]).includes(propertyName);
};

export const PRINT_LINE_STANDARD_NAMES = [
  PRINT_LABEL_LINE1,
  PRINT_LABEL_LINE2,
  PRINT_LABEL_LINE3,
  PRINT_LABEL_LINE4,
  PRINT_LABEL_LINE5,
  PRINT_LABEL_LINE6,
] as const;

export const isStandardPrintLineProperty = (propertyName: string): boolean =>
  (PRINT_LINE_STANDARD_NAMES as readonly string[]).includes(propertyName);

export interface PreferenceSectionGroup {
  title: string;
  description: string;
  propertyNames: readonly string[];
}

export const PREFERENCE_SECTION_GROUPS: Partial<
  Record<string, PreferenceSectionGroup[]>
> = {
  'Label Printing': [
    {
      title: 'Print Experiment Barcode',
      description: 'Define Parameter for Print Experiment Barcode here',
      propertyNames: [
        PRINT_LABEL_LINE1,
        PRINT_LABEL_LINE2,
        PRINT_LABEL_LINE3,
        PRINT_LABEL_LINE4,
        PRINT_LABEL_LINE5,
        PRINT_LABEL_LINE6,
      ],
    },
    {
      title: 'Print Experiment Information',
      description: 'Define Parameter for Print Experiment Information here',
      propertyNames: [
        PRINT_LABEL_EXPERIMENTINFORMATION_LINE1,
        PRINT_LABEL_EXPERIMENTINFORMATION_LINE2,
        PRINT_LABEL_EXPERIMENTINFORMATION_LINE3,
        PRINT_LABEL_EXPERIMENTINFORMATION_LINE4,
        PRINT_LABEL_EXPERIMENTINFORMATION_LINE5,
        PRINT_LABEL_EXPERIMENTINFORMATION_LINE6,
      ],
    },
    {
      title: 'General',
      description: '',
      propertyNames: [
        PRINTING_LABEL_PRINTER_NAME,
        LABEL_PRINTING_LABEL_AUTO_FORM_FEED_COUNT,
        LABEL_PRINTING_MULTI_COPIES_PRINT_COUNT,
        LABEL_PRINTING_DATE_FORMAT,
        PRINTING_LABEL_PRINTER_USE_GENERIC_BARCODES,
        PRINTING_LABEL_PRINTER_USE_MODIFIED_BASE64_BARCODES,
        PRINT_LABEL_MIN_CHARS_PER_TRUNCATED_TAG,
        BARCODE_SYSTEM_NAME,
        PRINTING_LABEL_PRINTER,
        PRINTING_LABEL_PRINTER_PLATE_NUM_CHARS_PER_LINE,
        PRINTING_LABEL_PRINTER_PLATE_HORIZ_TEXT_OFFSET,
        PRINTING_LABEL_PRINTER_PLATE_HORIZ_BARCODE_OFFSET,
        PRINTING_LABEL_PRINTER_PLATE_BARCODE_COMMAND,
        PRINTING_LABEL_PRINTER_PLATE_BARCODE_TEXT_VERTICAL_OFFSET,
        PRINTING_LABEL_PRINTER_PLATE_DISPLAY_BARCODE_TEXT,
        PRINTING_LABEL_PRINTER_PLATE_PRINT_BARCODE2,
        PRINTING_LABEL_PRINTER_PLATE_HORIZ_TEXT_OFFSET2,
        PRINTING_LABEL_PRINTER_PLATE_HORIZ_BARCODE_OFFSET2,
        PRINTING_LABEL_PRINTER_PLATE_BARCODE_COMMAND2,
        PRINTING_LABEL_PRINTER_PLATE_BARCODE_TEXT_HORIZONTAL_OFFSET2,
        PRINTING_LABEL_PRINTER_PLATE_BARCODE_TEXT_VERTICAL_OFFSET2,
        PRINTING_LABEL_PRINTER_PLATE_DISPLAY_BARCODE_TEXT2,
        PRINTING_LABEL_PRINTER_PLATE_PRINT_BARCODE_DELAY,
        PRINTING_LABEL_PRINTER_INGREDIENT_GENERIC_BARCODE_LENGTH,
        PRINTING_LABEL_PRINTER_INGREDIENT_NUM_CHARS_PER_LINE,
        PRINTING_LABEL_PRINTER_INGREDIENT_HORIZ_TEXT_OFFSET,
        PRINTING_LABEL_PRINTER_INGREDIENT_HORIZ_BARCODE_OFFSET,
        PRINTING_LABEL_PRINTER_INGREDIENT_BARCODE_COMMAND,
        PRINTING_LABEL_PRINTER_INGREDIENT_BARCODE_TEXT_VERTICAL_OFFSET,
        PRINTING_LABEL_PRINTER_INGREDIENT_DISPLAY_BARCODE_TEXT,
        PRINTING_LABEL_PRINTER_INGREDIENT_PRINT_DATE,
        PRINTING_LABEL_PRINTER_INGREDIENT_NULL_BARCODE,
        PRINTING_LABEL_PRINTER_PLATE_GENERIC_BARCODE_LENGTH,
        PRINTING_LABEL_PRINTER_PLATE_PLATE_TYPE_ID,
        PRINTING_LABEL_PRINTER_PLATE_PLATE_ID_ENCODING,
        PRINTING_LABEL_PRINTER_INGREDIENT_INGREDIENT_ID_ENCODING,
        PRINTING_LABEL_PRINTER_EXPERIMENTINFORMATION_NUM_CHARS_PER_LINE,
        PRINTING_LABEL_PRINTER_EXPERIMENTINFORMATION_HORIZ_TEXT_OFFSET,
        PRINTING_LABEL_PRINTER_EXPERIMENTINFORMATION_BARCODE_COMMAND,
      ],
    },
  ],
};

export const printLineParametersItems = [
  {
    id: 1,
    text: 'User Initials',
    value: '{UserInitials}',
    group: 'Tags for Experiment Label',
  },
  {
    id: 2,
    text: 'Dispense Date',
    value: '{DispenseDate:0:MM/dd/yy}',
    group: 'Tags for Experiment Label',
  },
  {
    id: 3,
    text: 'Creation Date',
    value: '{CreationDate:0:MM/dd/yy}',
    group: 'Tags for Experiment Label',
  },
  {
    id: 4,
    text: 'Today Date',
    value: '{TodayDate:0:MM/dd/yy}',
    group: 'Tags for Experiment Label',
  },
  {
    id: 5,
    text: 'Experiment Plate Number',
    value: '{ExperimentPlateNumber}',
    group: 'Tags for Experiment Label',
  },
  {
    id: 6,
    text: 'Experiment Plate ID',
    value: '{ExperimentPlateID}',
    group: 'Tags for Experiment Label',
  },
  {
    id: 7,
    text: 'Setup Temperature',
    value: '{SetupTemprature}',
    group: 'Tags for Experiment Label',
  },
  {
    id: 8,
    text: 'Incubation Temperature',
    value: '{IncubationTemprature}',
    group: 'Tags for Experiment Label',
  },
  {
    id: 9,
    text: 'Plate Number',
    value: '{PlateNumber}',
    group: 'Tags for Experiment Label',
  },
  {
    id: 10,
    text: 'Plate ID',
    value: '{PlateID}',
    group: 'Tags for Experiment Label',
  },
  {
    id: 11,
    text: 'Experiment ID',
    value: '{ExperimentID}',
    group: 'Tags for Experiment Label',
  },
  {
    id: 12,
    text: 'Project Name',
    value: '{ProjectName}',
    group: 'Tags for Experiment Label',
  },
  {
    id: 13,
    text: 'Experiment Name',
    value: '{ExperimentName}',
    group: 'Tags for Experiment Label',
  },
  {
    id: 14,
    text: 'Screen Lot Plate ID',
    value: '{ScreenLotPlateID}',
    group: 'Tags for Screen related Label',
  },
  {
    id: 15,
    text: 'Screen Lot Number',
    value: '{ScreenLotNumber}',
    group: 'Tags for Screen related Label',
  },
  {
    id: 16,
    text: 'Screen Lot Name',
    value: '{ScreenLotName}',
    group: 'Tags for Screen related Label',
  },
  {
    id: 17,
    text: 'Screen Lot ID',
    value: '{ScreenLotID}',
    group: 'Tags for Screen related Label',
  },
];
